/*@flow*/
import type { Node } from 'react'; /** @jsx jsx */
import { css, jsx } from '@emotion/core';
import { useEffect, createRef, useState } from 'react';
import OverlayFactory from 'comps/OverlayFactory';
import { Popover } from 'react-bootstrap';
import FormulaWidgetContainer from './FormulaWidgetContainer';
import LoadingBand from './LoadingBand';
import MoreInfo from './MoreInfo';
import useTextAnimation from 'lib/useTextAnimation';
import DownloadButton from './DownloadButton';
import evalFormula from './evalFormula';
import type { Metric } from './types';

const PopoverWrapper = OverlayFactory(Popover);

type PropsT = Metric & { url: string, label: string };

export default (props: PropsT): Node => {
  const [data, setData] = useState(0);
  const [isFetching, setFetching] = useState(false);
  const { valueFormula } = props;

  const transformData = (v) => {
    if (valueFormula) return evalFormula(valueFormula, v);
    return v;
  };

  useEffect(() => {
    if (!props.url) return;
    setFetching(true);
    fetch(props.url)
      .then((res) => res.json())
      .then((res) => setData(transformData(res.result)))
      .then(() => setFetching(false))
      .catch(() => setFetching(false));
  }, [props.url]);

  const dataRef = createRef();

  // Animate the numbers on the widget
  useTextAnimation(dataRef, data);

  return (
    <FormulaWidgetContainer>
      <div css={css('overflow: hidden;')}>
        <LoadingBand isVisible={isFetching} />
        <div css={css('font-size: 3rem;')}>
          <span>{props.prefix}</span>
          <span ref={dataRef}>{data}</span>
          <span css={css('font-size: 2rem;')}>{props.postfix}</span>
        </div>
        <div css={css('font-size: 1.6rem;')}>{props.label}</div>
        <div
          css={css('font-size: 1rem; position: relative;')}
          className="d-flex"
        >
          <span>{props.description}</span>
          <MoreInfo>
            <PopoverWrapper
              content={props.source}
              placement="left"
              id="more-info-tooltip"
            >
              <i className="fa fa-info-circle" />
            </PopoverWrapper>
          </MoreInfo>
          {props.custom && <DownloadButton id={props.id} />}
        </div>
      </div>
    </FormulaWidgetContainer>
  );
};
